import { styled } from '@mui/material';
import { ReactNode } from 'react';

export type BadgeProps = {
  children: ReactNode;
  className?: string;
  action?: ReactNode;
};

const StyledBadge = styled('div')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  maxWidth: '100%',
  background: 'var(--background-background-secondary-color)',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  border: '1px solid var(--stroke-stroke-primary-color)',
  color: 'var(--text-text-secondary-color)',
  borderRadius: theme.spacing(5),
  fontWeight: 500,
  fontSize: 12,
}));

const Content = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
});

const Action = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  flex: '0 0 auto',
});

export const Badge = ({ children, className, action }: BadgeProps) => (
  <StyledBadge className={className}>
    <Content>{children}</Content>
    {action ? <Action>{action}</Action> : null}
  </StyledBadge>
);
